export const housesData = [
  {
    id: 'all',
    name: 'All',
    imageUrl: '/hogwarts.webp',
  },
  {
    id: 'gryffindor',
    name: 'Gryffindor',
    imageUrl: '/gryffindor.webp',
  },
  {
    id: 'hufflepuff',
    name: 'Hufflepuff',
    imageUrl: '/hufflepuff.webp',
  },
  {
    id: 'slytherin',
    name: 'Slytherin',
    imageUrl: '/slytherin.webp',
  },
  {
    id: 'ravenclaw',
    name: 'Ravenclaw',
    imageUrl: '/ravenclaw.webp',
  },
];

export const charactersData = [
  {
    name: 'Harry Potter',
    house: 'Gryffindor',
    houseId: 'gryffindor',
  },
  {
    name: 'Cedric Diggory',
    house: 'Hufflepuff',
    houseId: 'hufflepuff',
  },
  {
    name: 'Luna Lovegood',
    house: 'Ravenclaw',
    houseId: 'ravenclaw',
  },
  {
    name: 'Severus Snape',
    house: 'Slytherin',
    houseId: 'slytherin',
  },
  {
    name: 'Ron Weasley',
    house: 'Gryffindor',
    houseId: 'gryffindor',
  },
  {
    name: 'Hermione Granger',
    house: 'Gryffindor',
    houseId: 'gryffindor',
  },
  {
    name: 'Gilderoy Lockhart',
    house: 'Ravenclaw',
    houseId: 'ravenclaw',
  },
  {
    name: 'Draco Malfoy',
    house: 'Slytherin',
    houseId: 'slytherin',
  },
  {
    name: 'Newt Scamander',
    house: 'Hufflepuff',
    houseId: 'hufflepuff',
  },
  {
    name: 'Tom Riddle',
    house: 'Slytherin',
    houseId: 'slytherin',
  },
];
